import { useRootContext } from "~/context/rootContext";
import { Gremlin, TradeStatus } from "~/types";

type TradeProps = {
  offeringUserProfilePic: string;
  requestedUserProfilePic: string;

  status?: TradeStatus | null;
  date?: string | null;

  sentByMe: boolean;

  offers: Pick<Gremlin, "image_thumbnail" | "id">[];
  requests: Pick<Gremlin, "image_thumbnail" | "id">[];
};

export default function Trade(props: TradeProps) {
  const {
    offeringUserProfilePic,
    requestedUserProfilePic,
    offers,
    requests,
    status,
    date,
    sentByMe,
  } = props;

  const { imageBaseUrl } = useRootContext();

  return (
    <div className="bg-card flex h-fit flex-row items-center rounded-md border px-6 py-4 font-card border-[#553075]">
      <p className="block md:hidden mr-2">
        {sentByMe ? "To" : "From"}
        {":"}
      </p>
      <img
        alt=""
        className={
          "w-12 rounded-full md:block 2xl:w-16" + " " + (sentByMe ? "hidden" : "")
        }
        src={offeringUserProfilePic}
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="mx-2 hidden h-6 w-6 md:block"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
        />
      </svg>

      <img
        alt=""
        className={
          "w-12 rounded-full md:block 2xl:w-16" + " " + (sentByMe ? "" : "hidden")
        }
        src={requestedUserProfilePic}
      />

      {status ? (
        <p className="ml-8 hidden text-xl font-bold capitalize md:block">
          {status.toLowerCase()}
        </p>
      ) : (
        <></>
      )}
      {date ? (
        <p className="text-sm lg:text-md ml-4 lg:ml-8 hidden md:block">
          Requested on {date}
        </p>
      ) : (
        <></>
      )}

      {/* TODO: apply these filters server side to reduce bandwidth, or at least on loader? */}
      <div className="mr-4 flex grow flex-row-reverse items-center gap-x-0 md:gap-x-2 lg:gap-x-4">
        {requests
          .filter((_, idx) => idx < 3)
          .map((request) => (
            <img
              key={request.id}
              alt=""
              className="-mx-4 lg:-mx-6 block h-12 w-12 object-contain object-bottom 2xl:h-16 2xl:w-16"
              src={`${imageBaseUrl}/${request.image_thumbnail}`}
            />
          ))}
        <div className="mx-6 lg:mx-8 h-12 w-[1px] bg-gray-400 2xl:h-16"></div>
        {offers
          .filter((_, idx) => idx < 3)
          .map((offer) => (
            <img
              key={offer.id}
              alt=""
              className="-mx-4 lg:-mx-6 block h-12 w-12 object-contain object-bottom 2xl:h-16 2xl:w-16"
              src={`${imageBaseUrl}/${offer.image_thumbnail}`}
            />
          ))}
      </div>
    </div>
  );
}
